import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// Inputs
import { TextInputField, Button, TextAreaField, CheckboxField } from '../../../helpers'
import { RadioButton } from "primereact/radiobutton"
import { FileUpload } from 'primereact/fileupload'
import Loading from "../../../common/Loading"

import MaterialImageGalleria from "./MaterialImageGalleria"

import { raiseToast } from "../../../services/redux/reducers/toast/toast"


const ProcessingImages = (props) => {
    
    const dispatch = useDispatch()

    const {
        imageURL,
        materialImages,
        productDescription,
        thumbnailImageId,
        isLoaderVisible,
        prevProductDescription,
        showProductDescriptionInput,
        showPrevProductDescriptionInput
    } = props

    const [isAddImageManually, setIsAddImageManually] = useState(false)
    const [productDescriptionType, setProductDescriptionType] = useState(null)

    useEffect(() => {
        if(materialImages.length >= 5 && isAddImageManually){
            setIsAddImageManually(false)
        }
    },[materialImages])

    const handleProdDescriptionType = (event) => {
        setProductDescriptionType(event.value)
    }

    const handleCloseMaterialImageAndDescription = () => {
        if(showPrevProductDescriptionInput && !productDescriptionType){
            return dispatch(raiseToast({ severity: 'error', detail: "Please select the right product description", life: 3000 }))
        }

        props.handleCloseProcessImageModal(productDescriptionType)
    }

    return (
        <div>
            <div className="mb-2">
                <MaterialImageGalleria
                    materialImages={materialImages}
                    setMaterialImages={props.setMaterialImages}
                    thumbnailImageId={thumbnailImageId}
                    setThumbnailImageId={props.setThumbnailImageId}
                    handleRemoveMaterialImage={props.handleRemoveMaterialImage}
                />
            </div>
            {
                !isAddImageManually ? 
                    <Button className="small-btn" label="Add Image Manually" onClick={() => setIsAddImageManually(true)} disabled={materialImages.length >= 5} />
                    :
                    (
                        materialImages.length < 5 && (
                            <div className="flex col-3 pl-0 pt-0 col-12 lg:mb-0">
                                <div className="flex flex-column col-12 mb-2 md:col-8 lg:col-9 lg:mb-0 md:pl-0">
                                    <TextInputField name="imageURL" labelText="Image URL" value={imageURL} onChange={(e) => props.handleImageURLChange(e)} />
                                </div>
                                {
                                    imageURL?.trim() ?
                                        <div className='mt-3 flex col-12 mb-2 md:col-4 lg:col-3 lg:mb-0'>
                                            <Button className="small-btn" label="Add Image URL" onClick={() => props.handleImageUrl(imageURL)} />
                                        </div>
                                        :
                                        <div className="flex flex-column col-12 md:col-4 lg:col-3 mt-3">
                                            <FileUpload mode="basic" name="materialImage" accept="image/*" customUpload auto multiple chooseLabel="Upload Image" uploadHandler={(files) => props.handleUploadMaterialImage(files)} />
                                        </div>
                                }
                            </div>
                        )
                    )
            }
            {
                showProductDescriptionInput && showPrevProductDescriptionInput ?
                    <div className="col-3 pl-0 pt-0 col-12 lg:mb-0 mt-3">
                        <h4>Choose right product description<span style={{ color: "red" }} className="from-required">*</span> </h4>
                    </div>
                    : null
            }
            <div className="flex flex-column">
                {
                    showPrevProductDescriptionInput ?
                        <div className="flex align-items-center">
                            <RadioButton
                                inputId="NEW"
                                name="productDescriptionType"
                                value="NEW"
                                onChange={handleProdDescriptionType}
                                checked={productDescriptionType === 'NEW'}
                            />
                            <label htmlFor="PREV" className="ml-1">Use New Product Description</label>
                        </div> : null
                }
                <div className="flex flex-column col-12 text-area mb-2">
                    <TextAreaField
                        name="productDescription"
                        labelText={!showPrevProductDescriptionInput && "Product Description"}
                        placeholder="Please enter product description"
                        maxLength={500}
                        rows={3}
                        autoResize
                        value={productDescription}
                        onChange={(e) => props.setProductDescription(e.target.value)}
                        disabled={showPrevProductDescriptionInput && productDescriptionType !== 'NEW'}
                    />
                </div>
            </div>
            {
                showPrevProductDescriptionInput ? (
                    <div className="flex flex-column">
                        <div className="flex align-items-center">
                            <RadioButton
                                inputId="PREV"
                                name="productDescriptionType"
                                value="PREV"
                                onChange={handleProdDescriptionType}
                                checked={productDescriptionType === 'PREV'}
                            />
                            <label htmlFor="PREV" className="ml-1">Use Previous Product Description</label>
                        </div>
                        <div className="flex flex-column col-12 text-area mb-2">
                            <TextAreaField
                                name="prevProductDescription"
                                placeholder="Please enter product description"
                                maxLength={500}
                                rows={3}
                                autoResize
                                value={prevProductDescription}
                                disabled={productDescriptionType !== 'PREV'}
                                onChange={(e) => props.setPrevProductDescription(e.target.value)}
                            />
                        </div>
                    </div>
                ) : null
            }
            <div className='mt-3 flex justify-content-end'>
                <Button label="Close" onClick={() => handleCloseMaterialImageAndDescription()} />
            </div>
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default ProcessingImages